export default __webpack_public_path__ + "static/media/logo-hu-white.a0436e99.svg";